import Asset from "../../../../../../../../../requests/apa/Asset"
import Utils from "../../../../../../../../../utils/Utils"

export const extractHeadersFromStats = (teams) => {
    if (!teams || teams.length === 0) return []
    
    const firstTeam = teams[0]
    if (!firstTeam || !firstTeam.stats) return []

    const baseHeader = [
        { key: 'position', label: 'RK' },
        { key: 'team', label: 'PAÍS' }
    ]
    
    const headers = Object.keys(firstTeam.stats).map(key => ({
        key: key,
        label: firstTeam.stats[key].label || key
    }))
    
    return [...baseHeader, ...headers]
}

export const tranformTeams = (teams) => {
    return teams.map(team => {
        const baseTeam = {
            position: Utils.cutPlayerString(team.position, 3),
            team: {
                id: team.team.teamId,
                name: Utils.cutPlayerString(team.team.name, 25),
                flagUrl: team && team.team && team.team.flagUrl ? team.team.flagUrl : Asset.get('eventodeportivo_placeholder_imagen_bandera_1')
            }
        }
        
        // Agregar dinámicamente todas las stats
        if (team.stats) {
            Object.keys(team.stats).forEach(key => {
                const statValue = team.stats[key] && team.stats[key].value !== undefined ? team.stats[key].value : 0
                baseTeam[key.toLowerCase()] = Utils.cutPlayerString(statValue, 3)
            })
        }
        
        return baseTeam
    }) 
}

export const createRankingResponse = (response) => {
    const { teamStatistics } = response 
    const rankings = teamStatistics.rankings[0]
    const { teams } = rankings
    return{
        headers: extractHeadersFromStats(teams),
        teams: tranformTeams(teams)
    }
}

export const createClassificationResponse = (response) => {
    const { teamStatistics } = response
    const teams = teamStatistics.classification[0].standings
    return{
        headers: extractHeadersFromStats(teams),
        teams: tranformTeams(teams)
    }
}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Paises/components/CountryDetailsModal/Components/CountryDetailsBody/Components/StandingsBody/utils.js